import React from "react";
import { MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SundayCityTourDetails = () => {
    const tourItems = [
        {
            title: "Lalbagh Botanical Garden",
            description:
                "Start the day with a calm and refreshing nature walk.",
            image: "/assets/garden.jpg",
            time: "9:00 AM - 10:30 AM",
        },
        {
            title: "Cubbon Park",
            description:
                "Experience Bangalore's green spaces in the city center.",
            image: "/assets/park.jpg",
            time: "10:45 AM - 12:00 PM",
        },
        {
            title: "Vidhana Soudha (Outside View)",
            description: "A must-visit landmark for photos and city identity.",
            image: "/assets/OIP.jpg",
            time: "12:15 PM - 1:00 PM",
        },
        {
            title: "Bangalore Palace",
            description:
                "Explore the royal and cultural heritage of Bangalore.",
            image: "/assets/place.jpg",
            time: "1:30 PM - 3:00 PM",
        },
        {
            title: "Sree Tirumalagiri Temple",
            description:
                "End the tour with a peaceful spiritual experience on Sunday.",
            image: "/assets/temple.jpg",
            time: "3:15 PM - 5:00 PM",
        },
    ];

    // 📍 Pickup locations
    const pickupLocations = ["Marathahalli (Spice Garden)", "Bellandur"];
    const navigate =  useNavigate();

    return (
        <div className="bg-gradient-to-b from-purple-50 via-indigo-50 to-white min-h-screen">
            {/* HERO */}
            <div className="relative h-72 bg-gradient-to-r from-purple-600 to-indigo-600 flex items-center justify-center">
                <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                    Sunday City Tour <br />
                    <span className="text-lg font-normal">
                        Temple Special Experience
                    </span>
                </h1>
            </div>

            <div className="max-w-6xl mx-auto px-4 py-12">
                {/* 📍 Pickup Locations */}
                <div className="bg-white rounded-3xl shadow-lg p-8 mb-16">
                    <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
                        Pickup Locations
                    </h2>

                    <div className="grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
                        {pickupLocations.map((location, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-5 p-6 rounded-2xl border hover:shadow-xl transition"
                            >
                                <div className="bg-gradient-to-br from-purple-600 to-indigo-600 text-white p-4 rounded-full">
                                    <MapPin size={22} />
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-800">
                                        {location}
                                    </p>
                                    <span className="text-sm text-gray-500">
                                        Morning Pickup
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* TOUR STOPS */}
                <div className="space-y-10">
                    {tourItems.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden"
                        >
                            <div className="md:flex">
                                {/* Image (NO NUMBER HERE) */}
                                <div className="md:w-2/5">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-60 md:h-full object-cover"
                                    />
                                </div>

                                {/* Content */}
                                <div className="md:w-3/5 p-6 flex flex-col justify-between">
                                    <div>
                                        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                                            {item.title}
                                        </h2>
                                        <p className="text-purple-600 font-medium mb-2">
                                            {item.time}
                                        </p>
                                        <p className="text-gray-600 leading-relaxed">
                                            {item.description}
                                        </p>
                                    </div>

                                    <div className="mt-6">
                                        <button className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-medium">
                                            Book This Stop
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* FINAL CTA */}
                <div className="text-center mt-20">
                    <button onClick={()=>navigate('/booking')} className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-lg px-12 py-4 rounded-2xl font-bold shadow-xl hover:scale-105 transition">
                        Book Full Sunday City Tour
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SundayCityTourDetails;
